import _extends from "babel-runtime/helpers/extends";
import { initialState } from "./reducer";
import { extractPath } from "@rosetta/redux-utils";

var localState = function localState(state) {
  return state && state.sre && state.sre.readingtracker || initialState;
};
var selectors = {
  /* Reading Tracker */
  getStateStatus: function getStateStatus(state) {
    return localState(state).status;
  },
  getSessionId: function getSessionId(state) {
    return localState(state).sessionId;
  },
  getSessionIsCanceled: function getSessionIsCanceled(state) {
    return localState(state).canceled === true;
  },
  getSilenceDetected: function getSilenceDetected(state) {
    return localState(state).silence;
  },
  getSoundLog: function getSoundLog(state) {
    return localState(state).soundLog;
  },
  getTrackerSoundObj: function getTrackerSoundObj(state) {
    return localState(state).soundObj;
  },
  getTrackerSessionData: function getTrackerSessionData(state) {
    return localState(state).sessionData;
  },
  getTrackerSessionText: function getTrackerSessionText(state) {
    return extractPath(localState(state), "sessionData.readingtrackersession.text");
  },
  getTrackerSessionScore: function getTrackerSessionScore(state) {
    return extractPath(localState(state), "finalResult.score.finalScore");
  },
  getTrackerFinalResult: function getTrackerFinalResult(state) {
    return localState(state).finalResult;
  },
  getTrackerSessionReference: function getTrackerSessionReference(state) {
    return extractPath(localState(state), "sessionData.reference");
  },
  getTrackerHypothesis: function getTrackerHypothesis(state) {
    return extractPath(localState(state), "sessionData.listensession.hypothesis.xmlString");
  },
  getTrackerSessionWindow: function getTrackerSessionWindow(state) {
    return extractPath(localState(state), "sessionData.window");
  },

  /* Reading Tracker Sound Playback */
  getPlaybackData: function getPlaybackData(state) {
    return localState(state).playbackData;
  },
  getPlaybackIsPlaying: function getPlaybackIsPlaying(state) {
    return localState(state).playbackIsPlaying === true;
  },
  getPlaybackIsComplete: function getPlaybackIsComplete(state) {
    return localState(state).playbackIsComplete === true;
  },
  getPlaybackInterrupted: function getPlaybackInterrupted(state) {
    return localState(state).playbackInterrupted === true;
  },
  getPlaybackCurrentTime: function getPlaybackCurrentTime(state) {
    return localState(state).playbackCurrentTime;
  },
  getPlaybackTotalTime: function getPlaybackTotalTime(state) {
    return extractPath(localState(state), "soundObj.sizeInMS");
  },
  getPlaybackWordStartIndex: function getPlaybackWordStartIndex(state) {
    return extractPath(localState(state), "playbackData.wordStartIndex");
  },
  getPlaybackWordEndIndex: function getPlaybackWordEndIndex(state) {
    return extractPath(localState(state), "playbackData.wordEndIndex");
  }
};

var selectorsV2 = {
  // for recording
  currentReadingTrackerWordIndex: function currentReadingTrackerWordIndex(state) {
    return extractPath(state, "sre.readingtracker.currentSpeakingWordIndex");
  },
  isReadingTrackerResultAvailable: function isReadingTrackerResultAvailable(state) {
    return extractPath(state, "sre.readingtracker.isResultAvailable");
  },
  // for graded results
  readingTrackerGradedWords: function readingTrackerGradedWords(state) {
    return extractPath(state, "sre.readingtracker.gradedWords");
  },
  readingTrackerFinalScore: function readingTrackerFinalScore(state) {
    return extractPath(state, "sre.readingtracker.finalScore");
  },
  // for playback (required params for speechEngine.createReadingTrackerPlaybackSession)
  readingTrackerSessionText: function readingTrackerSessionText(state) {
    return extractPath(state, "sre.readingtracker.text");
  },
  readingTrackerHypothesis: function readingTrackerHypothesis(state) {
    return extractPath(state, "sre.readingtracker.hypothesis");
  }
};

export default _extends({}, selectors, selectorsV2, {
  getReadingTrackerState: localState
});